<template>
  <div></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

.center-info {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  display: flex;
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 70px 90px;
  column-gap: 40px;
  row-gap: 40px;
  overflow-x: auto;
}

.info {
  position: relative;

  .text {
    width: 145px;
    line-height: 1.1rem;
  }

  .number {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

*::-webkit-scrollbar {
  width: 0px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
}
</style>